import React, { useContext, useState, useEffect } from "react";
import ToolComponent from "../../ToolComponent/ToolComponent";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import useSize from "../../../Hooks/useSize.js";
import useUpdateSizeValues from "../../../Hooks/useUpdateSizeValues.js";
import useGetCurrentsTools from "../../../Hooks/useGetCurrentsTools.js";
import useUpdateGlobalPosition from "../../../Hooks/useUpdateGlobalPosition.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Panel(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const [isDragOver, setDragover] = useState(false);
  const formContainerId = "formContainer"
  const currentToolIds = globalState.state.formData.currentTool.map(item=> item.id);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const updateSizeValues = useUpdateSizeValues();
  const updateGlobalPosition = useUpdateGlobalPosition();
  const getCurrentsTools = useGetCurrentsTools();
  const buildStyle = useBuildStyle();
  
  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const updateSize = (id, width, height) => {
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));

    updateSizeValues(updatedFormData, id, width, height);
    var currentsTools = [];
    getCurrentsTools(updatedFormData, currentsTools, currentToolIds);
    updatedFormData.currentTool = currentsTools;
    
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
  };
  
  const getMarginTop = (top) => {
    return top - parseInt(props.data.styles.fontSize.value.slice(0, -2)) / 2;
  };

  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    
    newStyle["border"] = isDragOver
      ? "2px dashed #1f79e1"
      : props.draggable && props.isSelected
      ? "1px dashed gray"
      : props.style.border.value;
    if (!props.draggable) newStyle["resize"] = "none"
    return newStyle;
  };

  const onDragStart = (e, template) => {
    
    const currentToolPosition = document.getElementById(template.id).getBoundingClientRect()
    
    template["clickRelativePosition"] = {left:e.clientX - currentToolPosition.x , 
      top:e.clientY - currentToolPosition.y}
 
    e.dataTransfer.setData("controlId", JSON.stringify(template));
    e.stopPropagation();
  };

  const canAdd = (template) => {
  
    return props.data.id !== template.id && !props.data.parentId.includes(template.id);
  };

  const drop = (e) => {
    
    e.preventDefault();
    var dataTransfer = e.dataTransfer.getData("controlId");
    if (dataTransfer){
    var template = JSON.parse(dataTransfer);
    if (canAdd(template)) {
      var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    
      const parentClient = document.getElementById(props.data.id)
      const parentClientRect = parentClient.getBoundingClientRect()
      var x = e.clientX + parentClient.scrollLeft ;
      var y = e.clientY + parentClient.scrollTop ;
      
      if (template.clickRelativePosition) {
       
        
        x = x  - (template.clickRelativePosition ? template.clickRelativePosition.left : 0)
        y = y  - (template.clickRelativePosition ? template.clickRelativePosition.top : 0)
      }
      
      template.styles.left.value = x - parentClientRect.x;
      template.styles.top.value = y - parentClientRect.y;
      
      if (template.styles.left.value> 0 && template.styles.top.value>0){
        
        template["left"] = {value:parentClientRect.x};
        template["top"] = {value:parentClientRect.y};
        template["scrollX"] = window.scrollX   ;
        template["scrollY"] = window.scrollY  ;
       
        //delete template.clickRelativePosition
        updateGlobalPosition(template);
        props.handleOnDrop(updatedFormData,
          {id:[props.data.id, ...props.data.parentId], globalId:[props.data.globalId, ...props.data.parentGlobalId]}
          //[props.data.id, ...props.data.parentId]
          , template)
      };
    };
  
  }
    setDragover(false);
    e.stopPropagation();
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
     e.stopPropagation() ;
  };
  
  return (
    <div
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      /*id={props.data.id}*/
      onDrop={(e) => drop(e, props.data.id)}
      onDragEnter={(e) => onDrag(e, true)}
      onDragLeave={(e) => onDrag(e, false)}
      key={props.data.id}>
      <div
        id={props.data.id} 
        className="panel"
        onClick={(e) => props.onClick(e, props.data)}
        style={getStyle()}>
        {props.data.metaData.map((template) => (
            <ToolComponent
              key={template.id}
              meta={template}
              draggable={props.draggable}
              position="absolute"
              onDragStart={(e) => onDragStart(e, template)}
              handleOnDrop={(updatedFormData,containerId, currentTemplate, schema) => 
                props.handleOnDrop(updatedFormData,containerId, currentTemplate, schema)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  updateSize(id, resizeWidth, resizeHeight)}
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
              //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
              onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
              onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
              onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
              onClick={(e, currentTemplate) => props.onClick(e, currentTemplate)}
            />
        ))}
      </div>
   
      {!props.isTabPanel &&
        <div id="labelPanel"
          style={{
            lineHeight: props.data.styles.fontSize.value, // + "px",
            top: getMarginTop(props.data.styles.top.value),
            left: props.data.styles.left.value + 10,
            fontSize: props.data.styles.fontSize.value,
            fontFamily: props.data.styles.fontFamily.value,
            color: props.data.styles.color.value,
            visibility: props.data.styles.visibility.value,
            background: "white",
            position: "absolute"}}>
          {props.data.properties.text.value} 
        </div>}
    </div>
  );
}
